const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGIN_FAILURE_401: 'USERS_LOGIN_FAILURE_401',
  LOGIN_FAILURE_SYNC_REQUIRED: 'USERS_LOGIN_FAILURE_SYNC_REQUIRED',
  API_FAILS: 'USERS_API_FAILS',
  GLOBAL_PHONE_FORMAT: 'GLOBAL_PHONE_FORMAT',
  LOGOUT: 'USERS_LOGOUT',
  API_TOKEN: 'API_TOKEN',
  ACCEPT_MG_TEARMS: 'ACCEPT_MG_TEARMS',
  MY_COMPANY_PERMISSION: 'MY_COMPANY_PERMISSION',
  MY_ACCOUNT_PERMISSION: 'MY_ACCOUNT_PERMISSION',
  REORDER_EXCLUDE_ITEMS: 'REORDER_EXCLUDE_ITEMS',
  DEALER_LOCATOR_PERMISSION: 'DEALER_LOCATOR_PERMISSION',
  ORDER_REVIEW_ACCOUNT_NUMBER: 'ORDER_REVIEW_ACCOUNT_NUMBER',
  SLEEPlAB_LOCATOR_PERMISSION: 'SLEEPlAB_LOCATOR_PERMISSION',
  GET_REQUEST_TYPE: 'GET_REQUEST_TYPE',
  GET_ALL_USER_LIST: 'GET_ALL_USER_LIST',
  AWSS3_MAX_ALLOWABLE_FILE_SIZE: 'AWSS3_MAX_ALLOWABLE_FILE_SIZE',
  AWSS3_MAX_ALLOWABLE_FILE_TYPES: 'AWSS3_MAX_ALLOWABLE_FILE_TYPES',
  AWSS3_MAX_ALLOWABLE_FILES: 'AWSS3_MAX_ALLOWABLE_FILES',
  CTO_ALLOWABLE_CUSTOMERS: 'CTO_ALLOWABLE_CUSTOMERS',
  LOCALE_LANG_SET: 'LOCALE_LANG_SET',
  MY_COMPANY_ADMIN_ROLE_COUNT: 'MY_COMPANY_ADMIN_ROLE_COUNT',
  ITEM_LIMIT_COUNT: 'ITEM_LIMIT_COUNT',
  GLOBAL_DATE_FORMAT: 'GLOBAL_DATE_FORMAT',
  SHIP_TO_ENABLE: 'SHIP_TO_ENABLE',
  SET_USER_FLAG: "SET_USER_FLAG",
  BACK_ORDERED_FLAG: 'BACK_ORDERED_FLAG',
  FREIGHT_DETAILS: 'FREIGHT_DETAILS',
  IS_COVEO_SEARCH_ENABLED: 'IS_COVEO_SEARCH_ENABLED',
  SET_MARKETING_BANNER_DATA: 'SET_MARKETING_BANNER_DATA',
  SET_FOOTER_TOP_MARGIN: 'SET_FOOTER_TOP_MARGIN',
  SET_HAS_MULTIPLE_ACCOUNTS: 'SET_HAS_MULTIPLE_ACCOUNTS',
};
export default userConstants;
